import { useState } from 'react'

export const NavigationStates = () => {
    const [scrollDirection, setscrollDirection] = useState('up')

    return {
        scrollDirection:{data: scrollDirection, set: setscrollDirection}
    }
}